module.exports = __webpack_public_path__ + "img/logo-write-background.0ff17029.svg";